if (!customElements.get('road-rex-gallery')) {
  customElements.define('road-rex-gallery', class RoadRexGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rrGalleryReady === 'true') return;
      this.dataset.rrGalleryReady = 'true';

      this.filterButtons = Array.from(this.querySelectorAll('[data-rr-gallery-filter]'));
      this.items = Array.from(this.querySelectorAll('[data-rr-gallery-item]'));
      this.dialog = this.querySelector('[data-rr-gallery-dialog]');

      this.filterButtons.forEach((button) => {
        button.addEventListener('click', () => this.filter(button.dataset.rrGalleryFilter, button));
      });

      this.querySelectorAll('[data-rr-gallery-open]').forEach((button) => {
        button.addEventListener('click', () => this.open(button));
      });

      this.querySelector('[data-rr-gallery-close]')?.addEventListener('click', () => this.dialog?.close());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }

    filter(category, activeButton) {
      this.filterButtons.forEach((button) => {
        const isActive = button === activeButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      this.items.forEach((item) => {
        item.hidden = category !== 'all' && item.dataset.category !== category;
      });
    }

    open(button) {
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      const image = this.dialog.querySelector('[data-rr-gallery-dialog-image]');
      const title = this.dialog.querySelector('[data-rr-gallery-dialog-title]');
      const caption = this.dialog.querySelector('[data-rr-gallery-dialog-caption]');
      const meta = this.dialog.querySelector('[data-rr-gallery-dialog-meta]');

      if (image) {
        image.src = button.dataset.fullImage || '';
        image.alt = button.dataset.title || '';
      }
      if (title) title.textContent = button.dataset.title || '';
      if (caption) caption.textContent = button.dataset.caption || '';
      if (meta) meta.textContent = button.dataset.meta || '';

      this.dialog.showModal();
    }
  });
}
